var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9612 14.5531V6.44677L21.1311 10.5006L12.9612 14.5531ZM5.76411 0.166626C1.83777 0.166626 0.243164 3.19154 0.243164 6.92527V14.0736C0.243164 17.8071 2.005 20.8333 5.93239 20.8333H26.1349C30.06 20.8333 31.4034 17.8071 31.4034 14.0736V6.92527C31.4034 3.19154 30.2277 0.166626 26.3003 0.166626H5.76411Z",
    fill: "#FFDD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeYellow);
export default __webpack_public_path__ + "static/media/youtube-yellow.bc0efe497c3ee48a35be837e64c1a8f4.svg";
export { ForwardRef as ReactComponent };